@if (dialogRef) {
	<div class="mep-dialog-header-icon">
		<mat-icon>folder_shared</mat-icon>
	</div>
}

<div id="project-data-content" #projectDetailDrawer>
	<div id="project-data-header">
		<mat-toolbar [ngClass]="{dialog: dialogRef}">
			@if (!isAddMode) {
				<span class="example-spacer">{{ _lang("headline") }}</span>
			}
			@if (isAddMode) {
				<span id="detail-title" class="example-spacer" [ngClass]="{dialog: dialogRef}">
					{{ _lang("headline-add-mode") }}
				</span>
			}
			<ng-container *appRequiresPermission="'UPDATE_BU'; entity: 'PROJECT'">
				@if (!isEditMode) {
					<ng-container>
						@if (!dialogRef) {
							<button class="mep-btn-small" (click)="activateEditMode()" id="toggleButton">
								<mat-icon matTooltip="{{ _lang('edit') }}">edit</mat-icon>
							</button>
						}
						@if (!dialogRef) {
							<button class="mep-btn-small" (click)="openChangeProjectEndDialog()">
								<mat-icon matTooltip="{{ 'mep.components.extend-or-move-project-dialog.heading' | translate }}"
									>date_range
								</mat-icon>
							</button>
						}
					</ng-container>
					@if (!dialogRef) {
						<button class="mep-btn-small" (click)="openCopyAssignmentsDialog()">
							<mat-icon matTooltip="{{ _lang('copy-assignments') }}"> file_copy</mat-icon>
						</button>
					}
					@if (project?.projectName && (project?.businessUnit === "HSC" || project?.businessUnit === "GBV")) {
						<app-cross-application-link [projectName]="project.projectName"></app-cross-application-link>
					}
					@if (!dialogRef) {
						<button
							class="mep-btn-small float-start ms-1 d-block"
							matTooltip="{{ 'mep.components.edit-project-access-dialog.tooltip' | translate }}"
							(click)="openManageDialog()"
						>
							<mat-icon>settings</mat-icon>
						</button>
					}
				}
			</ng-container>
			@if (isEditMode && !dialogRef) {
				<button
					class="mep-btn-small"
					(click)="submitProject()"
					[disabled]="!allRequiredFieldIsFilled() || !isAssignmentBetweenProject() || invalidProjectProbabilities()"
					appSaveHotkey
					id="submitButton"
				>
					<mat-icon matTooltip="{{ _lang('save') }}">save</mat-icon>
				</button>
			}
			@if ((isEditMode || isReadonlyMode) && !dialogRef) {
				<button class="mep-btn-small" (click)="deactivateEditMode(); checkToGetProjectTimeSlices()">
					<mat-icon matTooltip="{{ _lang('close') }}">close</mat-icon>
				</button>
			}
		</mat-toolbar>
	</div>
	<div id="project-data-body">
		<mat-progress-bar id="project-data-loading_bar" mode="indeterminate" [hidden]="!loading"></mat-progress-bar>

		@if (isAddMode) {
			<div class="keep-project-ifo-checkbox">
				<mat-checkbox
					(change)="toggleMultiProjectSaveMode()"
					[checked]="isMultiProjectSaveMode"
					matTooltip="{{ _lang('keepProjectDataTooltip') }}"
					>{{ _lang("keepProjectData") }}
				</mat-checkbox>
			</div>
		}

		<mat-accordion id="project-data-projectProbabilitiesPanel">
			<mat-expansion-panel class="m-3" expanded #projectProbabilitiesPanel>
				<mat-expansion-panel-header>
					<mat-panel-title class="d-block">
						{{ _lang("probabilities") }}
						@if (overlappingProjectProbabilities()) {
							<small class="text-danger d-block">{{ _lang("overlapping-time-slices") }}</small>
						}
					</mat-panel-title>
					@if (isEditMode) {
						<button
							mat-icon-button
							color="primary"
							id="project-data-add-time-slice"
							(click)="addSlice(); $event.stopPropagation(); projectProbabilitiesPanel.open()"
						>
							<mat-icon>add</mat-icon>
						</button>
					}
				</mat-expansion-panel-header>
				@if (projectProbabilitiesDataSource.data.length !== 0) {
					<table
						class="kapa-table"
						[class.edit]="isEditMode"
						mat-table
						[dataSource]="projectProbabilitiesDataSource"
						matSort
						matSortDisableClear
						matSortActive="effectiveFrom"
						#capaTableSort="matSort"
						matSortDirection="asc"
						#table
					>
						<!-- //NOSONAR -->
						<ng-container matColumnDef="effectiveFrom">
							<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("from") }}</th>
							<td mat-cell *matCellDef="let row">
								<mat-form-field class="noAdditionalPadding mat-form-field-w-auto">
									<input
										[formControl]="row.effectiveFrom"
										[matDatepicker]="pickerFrom"
										matInput
										[readonly]="!isEditMode"
										appOnlyNumbers
										autocomplete="off"
										class="timeSliceInput"
										id="project-data-time-slice-effectiveFrom"
										(dateChange)="onEffectiveFromChange($event, row)"
										required
									/>
									<mat-datepicker-toggle [hidden]="!isEditMode" matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
									<mat-datepicker #pickerFrom></mat-datepicker>
								</mat-form-field>
							</td>
						</ng-container>
						<ng-container matColumnDef="effectiveUntil">
							<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("until") }}</th>
							<td mat-cell *matCellDef="let row">
								<mat-form-field class="noAdditionalPadding mat-form-field-w-auto">
									<input
										[formControl]="row.effectiveUntil"
										[matDatepicker]="pickerUntil"
										[readonly]="!isEditMode"
										appOnlyNumbers
										autocomplete="off"
										class="timeSliceInput"
										id="project-data-time-slice-effectiveUntil"
										matInput
									/>
									<mat-datepicker-toggle [hidden]="!isEditMode" matSuffix [for]="pickerUntil"></mat-datepicker-toggle>
									<mat-datepicker
										#pickerUntil
										[startAt]="row.effectiveUntil.value || row.effectiveFrom.value"
									></mat-datepicker>
									@if (row.effectiveUntil.hasError("fromToDate")) {
										<mat-error>
											<strong>{{ "mep.components.general.validation.date-error" | translate }}</strong>
										</mat-error>
									}
								</mat-form-field>
							</td>
						</ng-container>
						<ng-container matColumnDef="probability">
							<th id="probe-cell" mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("prob_short") }}</th>
							<td id="prob" mat-cell *matCellDef="let row">
								<mat-form-field class="noAdditionalPadding mat-form-field-w-auto">
									<input
										[formControl]="row.probability"
										[readonly]="!isEditMode"
										class="capacity"
										matInput
										type="number"
										min="0"
										max="100"
									/>
									<span matSuffix>&nbsp;%&nbsp;</span>
								</mat-form-field>
							</td>
						</ng-container>
						<ng-container matColumnDef="delete">
							<th id="trash-header" mat-header-cell *matHeaderCellDef></th>
							<td id="trash" mat-cell *matCellDef="let row">
								@if (isEditMode && projectProbabilitiesDataSource.data.length > 1) {
									<button
										(click)="deleteSlice(row)"
										id="project-data-delete-time-slice"
										color="primary"
										matTooltip="{{ _lang('delete_timeslice') }}"
										mat-icon-button
									>
										<mat-icon>delete</mat-icon>
									</button>
								}
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="projectProbabilitiesDisplayedColumns; sticky: true"></tr>
						<tr mat-row *matRowDef="let row; columns: projectProbabilitiesDisplayedColumns"></tr>
					</table>
				}
			</mat-expansion-panel>
		</mat-accordion>

		<!--add employees to the project that is being created-->

		@if (isAddMode) {
			<mat-expansion-panel
				id="project-data-addEmployeePanelExpanded"
				class="m-3"
				[(expanded)]="addEmployeePanelExpanded"
				expanded
			>
				<mat-expansion-panel-header>
					<mat-panel-title class="d-block"
						>{{ _lang("employees-to-add-to-project") }}
						@if (!isAssignmentBetweenProject()) {
							<small class="text-danger d-block">{{ _lang("employee-assignment-betweenProject") }}</small>
						}
					</mat-panel-title>
					<button
						(click)="openAddEmployeeToProjectDialog(); $event.stopPropagation()"
						color="primary"
						id="project-data-add_employee-to-project"
						mat-icon-button
						matTooltip="{{ _lang('add-employees-to-project') }}"
					>
						<mat-icon>add</mat-icon>
					</button>
				</mat-expansion-panel-header>
				<!--display time slices and capacity-->
				@if (isAddMode) {
					<form class="row justify-content-start" [formGroup]="formGroup">
						<div class="col-5 mat-form-field-padding picker-max-width">
							<mat-form-field class="noAdditionalPadding">
								<mat-label>{{ _lang("from") }}</mat-label>
								<input
									(dateInput)="setEffectiveFromDate($event)"
									[matDatepicker]="pickerFrom"
									[ngModel]="addEmployeeToProjectElement.effectiveFrom"
									appOnlyNumbers
									autocomplete="off"
									formControlName="effectiveFrom"
									id="project-data-add_employee-to-project-effectiveFrom"
									matInput
									required
								/>
								<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
								<mat-datepicker #pickerFrom></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="col-5 mat-form-field-padding picker-max-width">
							<mat-form-field class="noAdditionalPadding">
								<mat-label>{{ _lang("until") }}</mat-label>
								<input
									(dateInput)="setEffectiveUntilDate($event)"
									[matDatepicker]="pickerUntil"
									[ngModel]="addEmployeeToProjectElement.effectiveUntil"
									appOnlyNumbers
									autocomplete="off"
									formControlName="effectiveUntil"
									id="project-data-add_employee-to-project-effectiveUntil"
									matInput
									required
								/>
								<mat-datepicker-toggle matSuffix [for]="pickerUntil"></mat-datepicker-toggle>
								<mat-datepicker #pickerUntil></mat-datepicker>
								@if (formGroup.controls.effectiveUntil.hasError("forbiddenEndDate")) {
									<mat-error>
										{{ _lang("forbiddenEndDate") }}
									</mat-error>
								}
							</mat-form-field>
							@if (
								this.addEmployeeToProjectElement.employees.length > 0 && !addEmployeeToProjectElement.effectiveUntil
							) {
								<mat-error>
									{{ _lang("required") }}
								</mat-error>
							}
						</div>
						<div class="col-2 mat-form-field-padding">
							<mat-form-field class="noAdditionalPadding capa-cell">
								<input
									type="number"
									appOnlyNumbers
									matInput
									required
									class="capa-cell"
									formControlName="capacity"
									placeholder="{{ _lang('capacity') }}"
									autocomplete="off"
									[(ngModel)]="addEmployeeToProjectElement.capacity"
									(ngModelChange)="setCapacity($event)"
								/>
								@if (formGroup.controls.capacity.invalid) {
									<mat-error>
										{{ _lang("scope-placeholder") }}
										<strong>
											{{ "mep.components.employee-edit.needed" | translate }}
										</strong>
									</mat-error>
								}
								@if (formGroup.controls.capacity.hasError("max") || formGroup.controls.capacity.hasError("min")) {
									<mat-error>
										{{ _lang("invalid-scope") }}
									</mat-error>
								}
								@if (formGroup.get("capacity").value !== "") {
									<span class="m-1" matSuffix>%</span>
								}
							</mat-form-field>
						</div>
					</form>
				}
				<!--display names of employees that will be added to the project-->
				@if (employeesToProjectDataSource?.data?.length > 0) {
					<div class="row">
						<table mat-table [dataSource]="employeesToProjectDataSource">
							<!-- //NOSONAR -->
							<ng-container matColumnDef="firstName">
								<th mat-header-cell *matHeaderCellDef>{{ _lang("name") }}</th>
								<td mat-cell *matCellDef="let employee">{{ employee.firstName }}</td>
							</ng-container>
							<ng-container matColumnDef="lastName">
								<th mat-header-cell *matHeaderCellDef>{{ _lang("surname") }}</th>
								<td mat-cell *matCellDef="let employee">{{ employee.lastName }}</td>
							</ng-container>
							<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
						</table>
					</div>
				}
			</mat-expansion-panel>
		}

		<!--Button to add a sourcecode repository-->
		@if (isCurrentClientGBP()) {
			<div id="project-data-sourcecode-dialog" class="ms-3">
				@if (isEditMode) {
					<button class="mep-btn-big" (click)="openSourceCodeDialog()" id="project_data_input-source_code_storage">
						<mat-icon>storage</mat-icon>
						{{ _lang("attributes.add_source_code_storage") }}
					</button>
				}
				@if ((!this.sourceCodeStorage || !this.project.sourceCodeStorageLocation) && isAddMode) {
					<mat-hint [ngStyle]="{color: 'red'}">
						{{ _lang("attributes.hint_add_repository_to_project") }}
					</mat-hint>
				}
			</div>
		}

		@if (isCurrentClientGBP() && this.project.sourceCodeStorageLocation) {
			<div class="border rounded m-3 p-3">
				<div class="row me-3 ms-2">
					<div class="text-secondary ms-2">{{ _lang("attributes.source_code_storage") }}</div>
					<div>{{ showSourceCodeStorageLocation() }}</div>
				</div>
				<div class="row mx-2">
					@if (this.project.stackIntegratedStorage) {
						<div class="text-secondary ms-2">
							{{ _lang("attributes.stack_integrated_storage") }}
						</div>
					}
					<div matTooltip="{{ this.project.stackIntegratedStorage }}">
						{{ this.project.stackIntegratedStorage | truncateText: 40 }}
					</div>
				</div>
				<div class="row mx-2">
					@if (this.project.msgHub) {
						<div class="text-secondary ms-2">{{ "msg.HUB:  " }}</div>
					}
					<div matTooltip="{{ this.project.msgHub }}">{{ this.project.msgHub | truncateText: 50 }}</div>
				</div>
				<div class="row mx-2">
					@if (this.project.cloudSourceStorage) {
						<div class="text-secondary ms-2">
							{{ _lang("attributes.other_cloud_source_code") }}
						</div>
					}
					<div matTooltip="{{ this.project.cloudSourceStorage }}">
						{{ this.project.cloudSourceStorage | truncateText: 50 }}
					</div>
				</div>
				<div class="row mx-2">
					@if (this.project.reasonForOtherCloudSource) {
						<div class="text-secondary ms-2">
							{{ _lang("attributes.reason_for_other_cloudsource") }}
						</div>
					}
					<div matTooltip="{{ this.project.reasonForOtherCloudSource }}">
						{{ this.project.reasonForOtherCloudSource | truncateText: 50 }}
					</div>
				</div>
			</div>
		}

		<div class="col p-3">
			<app-project-data-input
				[isEditMode]="isEditMode"
				[isAddMode]="isAddMode"
				[project]="project"
				(isDataEdited)="inputModelChanged($event)"
				(statusChanged)="onProjectStatusChanged($event)"
				(projectUpdated)="onProjectUpdated($event)"
				[projectProbabilitiesDataSource]="projectProbabilitiesDataSource"
			></app-project-data-input>
		</div>
	</div>
	@if (dialogRef) {
		<div class="mep-dialog-actions">
			<button
				class="mep-btn-dialog-secondary"
				appEscapeHotkey
				(click)="deactivateEditMode(); checkToGetProjectTimeSlices()"
			>
				{{ "mep.components.general.cancel" | translate }}
			</button>
			<button
				class="mep-btn-dialog-primary"
				appSaveHotkey
				(click)="submitProject()"
				[disabled]="
					!allRequiredFieldIsFilled() ||
					!isAssignmentBetweenProject() ||
					invalidProjectProbabilities() ||
					(isCurrentClientGBP() && project.sourceCodeStorageLocation === undefined)
				"
			>
				{{ "mep.components.general.save" | translate }}
			</button>
		</div>
	}
</div>
